<template>
  <!-- content start -->
  <div class="content">
    <QuizHeader/>
    <div class="" style="margin-left: 10px;margin-right: 10px; margin-top: 58px">
      <div v-for="(item, index) in quizzes" v-if="quizzes.length>0">
        <Quiz
            :quiz_data= item
        />
      </div>
      <div v-if="quizzes.length===0" class="no-quiz height-90 align-ver center-hor bg-light">
        <div style="display: flex; justify-content: center; align-items: center; width: 100%">
          <img src="@/assets/no-data.svg" class="w20" style="width: 20%;">
        </div>
        <div> No Tournaments Live. Please Check back later</div>
      </div>
    </div>
  </div>
  <!-- content end -->
</template>

<script>
import Quiz from '@/components/quiz-list-card'
import QuizHeader from '@/components/quiz-header'
import axios from "axios"
export default {
  name: 'quiz-zone',
  props: {
    showAddTask: Boolean,
  },
  components: {
    Quiz,
    QuizHeader,
  },
  data() {
    return {
      quizDetails: [],
      quizzes: [],
      is_shimmer: true
    }
  },
  methods: {
    showShimmer: function() {
      return this.is_shimmer;
    },
    fetchQuiz() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/quiz_games';
      var headers = self.$store.getters.headers;
      axios.get(url, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          // console.log(data)
          self.quizzes = data.games;
          this.is_shimmer = false;
          if(self.quizzes.length===0) {
            this.is_shimmer = true;
          }
        } else {
          if(self.quizzes.length===0) {
            this.is_shimmer = false;
          }
          console.log("Error fetching the Quiz list");
        }
      })
    }
  },
  created() {
    // this.$emit('handleHideFooter');
    this.$store.state.showHeader = false;
    this.fetchQuiz();
    document.documentElement.style.setProperty('--bg-light-color',this.$store.state.bg_theme+'59');
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = true;
    this.$store.state.quizDetailsTitle = "Quiz";
  }
}
</script>
<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  @import '../assets/quiz-styles/bootstrap.css';

  .no-quiz {
    text-align: center;
    background: #ffffff;
    padding: 1rem;
    height: 70vh;
    border-radius: 5px;
  }
  .no-quiz img {
    padding-top: 70px;
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/screens/quiz-zone.vue